import { masmovilPalette, llamayaPalette } from './colors'

export const masmovilRadioOverride = {
  MuiRadio: {
    root: {
      '&.MuiRadio-colorPrimary.Mui-checked': {
        color: masmovilPalette.secondary.main,
      },
    },
  },
}

export const llamayaRadioOverride = {
  MuiRadio: {
    root: {
      '&.MuiRadio-colorPrimary.Mui-checked': {
        color: llamayaPalette.secondary.main,
      },
    },
  },
}
